<template>
  <div class="wf-product-category-refinements">
    <div class="wf-product-refinement-list wf-product-refinement-list-expanded">
      <div class="wf-product-refinement-list-header">
        <button
          type="button"
          class="btn wf-product-refinement-list-header-toggle"
          data-toggle="collapse"
          :data-target="`.wf-product-refinement-collapse-paint`"
        >
          {{ $resourceString["benjaminMoore.Filter.Color"] }}
          <span
            class="
                png-icon
                png-icon-icons-glyph--k-btn-minus-active
                wf-product-refinement-list-header-toggle-inactive
              "
          />
          <span
            class="
                png-icon
                png-icon-icons-glyph--k-btn-expand-ol
                wf-product-refinement-list-header-toggle-active
              "
          />
        </button>
      </div>
      <div
        class="wf-product-refinement-list-items collapse show"
        :class="`wf-product-refinement-collapse-paint`"
      >
        <div>
          <div
            class="
                wf-product-refinement-list-item row m-2
              "
          >
            <div
              @click="colorFilter(item.key)"
              :class="['benjamin-paint', selectedColor && selectedColor.includes(item.key) ? 'active' : '']"
              v-for="item in colorsMap"
              :key="item.hex"
              :style="{ backgroundColor: item.hex }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <p class="info-text-on-left-side">
      {{ $resourceString["benjaminMoore.Filter.info"] }}
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BenjaminColor from "../../../scripts/benjamin-moore-paints.js";

export default {
  components: {},
  computed: {
    ...mapGetters({
      selectedColor: "benjaminMoore/selectedColor"
    })
  },
  data() {
    return {
      colorsMap: {}
    };
  },
  methods: {
    ...mapActions({
      getBenjaminMooreProducts: "benjaminMoore/getBenjaminMooreProducts"
    }),
    colorFilter(key) {
      this.getBenjaminMooreProducts({ color: key });
    }
  },
  created() {
    this.colorsMap = BenjaminColor.colorMap();
  }
};
</script>

<style scoped>
.benjamin-paint {
  width: 50px;
  height: 50px;
  margin: 5px;
  cursor: pointer;
  border: 1px solid #ccc;
}
.benjamin-paint.active{
  border: 2px solid #da382d;
}
.wf-product-refinement-list-header-toggle:focus{
  box-shadow: none;
}
.info-text-on-left-side{
  padding: 0 1rem;
  font-size: 18px;
}
</style>
